<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { useThemeStore } from '@/Stores/Theme';
import { useAuth } from '@/Composables/Auth';
const themeStore = useThemeStore();
const auth = useAuth();
</script>

<template>
    <Link :href="'/'">
        <div class="login-page-logo">
            <img :src="auth.logo.value.full" alt="Logo" class="login-page-logo-img">
        </div>
    </Link>
</template>